<template>
	<div class="app-contact transition-contact" id="router">
		<h2 class="home-title">CONTACTO</h2>
		<div class="app-wrapper">
			<form 
				class="app-form"
			 	@submit.prevent="onSubmit">
				<div class="form-row flex flex-between">
					<div class="form-control">
						<input 
							type="text" 
							class="form-input" 
							placeholder="Nombre *" 
							v-model="contact.fullName"/>
					</div>
					<div class="form-control">
						<input 
							type="text" 
							class="form-input" 
							placeholder="Correo *" 
							v-model="contact.email"/>
					</div>
					<div class="form-control">
						<input 
							type="text" 
							class="form-input" 
							placeholder="Asunto" 
							v-model="contact.subject"/>
					</div>
				</div>
				<div class="form-row">
					<div class="form-control">
						<textarea 
							class="form-textarea" 
							placeholder="Escribe tu mensaje"
							v-model="contact.description"></textarea>
					</div>
				</div>
				<div class="form-row">
					<div class="form-control text-center">
						<button 
							type="submit"
							:disabled="isFetching" 
							class="btn btn-black btn-medium app-contact-button"
							>{{ isFetching ? 'Enviando...' : 'Enviar' }}</button>
					</div>
				</div>
			</form>
		</div>
		<div class="app-contact-map">
			<gmap-map
				:center="center"
				:zoom="16"
				class="map-contact"
			>
     		<gmap-marker
					icon="https://ws-aris.s3.amazonaws.com/static/icon-map.svg"
					v-for="(m, index) in markers" 
					:key="index"
					:position="m.position"
					@click="toggleInfo(m)"
					class="app-contact-map-icon"
				></gmap-marker>
				<gmap-info-window 
					:opened="infoOpened" 
					@closeclick="closeInfo"
					:options="infoOptions"
					:position="infoPosition">
					<p>{{companyData.address}}</p>
				</gmap-info-window>
    	</gmap-map>
		</div>
	</div>
</template>

<script>
function companyData(value) {
	if (value.latitude && value.longitude) {
		this.center.lat = value.latitude;
		this.center.lng = value.longitude;
	} else {
		this.center.lat = -12.0398200;
		this.center.lng = -77.0745303;
	}
}

function onSubmit() {
	const URL_NOTIFICATIONS = `send-notification/contacts/${process.env.APP_CODE}`;

	if (!this.contact.fullName.length) {
		this.showError('Necesitamos un nombre para poder continuar');
		return false;
	} else if (!this.validName(this.contact.fullName)) {
		this.showError('Ingresa un nombre válido');
		return false;
	}

	if (!this.contact.email.length) {
		this.showError('Necesitamos un email para ponernos en contacto contigo');
		return false;
	} else if (!this.validEmail(this.contact.email)) {
		this.showError('Ingresa un email válido');
		return false;
	}

	if (!this.contact.description.length) {
		this.showError('Parece que olvidaste tu mensaje...');
		return false;
	} else if (!this.validDescription(this.contact.description)) {
		this.showError('Tu mensaje tiene algunos caracteres raros, edítalos por favor');
		return false;
	}

	this.isFetching = true;

	return this.$http.post(URL_NOTIFICATIONS, this.contact).then(() => {
		this.isFetching = false;
		this.showNotification('Gracias por escribirnos, Nuestro equipo se pondrá en contacto contigo lo más pronto posible');
		setTimeout(() => {
			this.contact = {
				fullName: '',
				email: '',
				subject: '',
				description: '',
			};
		}, 6000);
	}).catch(() => {
		this.showError('Algo salió mal enviando estos datos, inténtalo de nuevo por favor.');
		this.isFetching = false;
	});
}

function validName(name) {
	const re = /^([^0-9]*)$/;
	return re.test(name);
}

function validEmail(email) {
	const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	return re.test(email);
}

function validDescription(description) {
	const re = /^([a-zA-Z0-9 _-]+)$/;
	return re.test(description);
}

function closeInfo() {
	this.infoOpened = false;
}

function toggleInfo(marker) {
	this.infoPosition = marker.position;
	this.infoOpened = !this.infoOpened;
}

function data() {
	return {
		center: {
			lat: -12.0398200,
			lng: -77.0745303,
		},
		markers: [
			{
				position: {
					lat: -12.0396600,
					lng: -77.0741803,
				},
			},
		],
		places: [],
		currentPlace: null,
		contact: {
			fullName: '',
			email: '',
			subject: '',
			description: '',
		},
		isFetching: false,
		infoOpened: false,
		infoOptions: {
			pixelOffset: {
				width: 0,
				height: -35,
			},
		},
		infoPosition: null,
	};
}

export default {
	name: 'app-contact',
	data,
	props: {
		companyData: {
			default: () => {},
			type: Object,
		},
	},
	methods: {
		onSubmit,
		validName,
		validEmail,
		validDescription,
		toggleInfo,
		closeInfo,
	},
	watch: {
		companyData,
	},
};
</script>

<style lang="scss" scoped>
.app-contact {
	padding: 55px 0 0;
}

.home-title {
	@include font-maison-bold();
	@include font-size(24);
	margin-bottom: 54px;
	position: relative;
	text-align: center;
	

	&::before,
	&::after {
		background-color: rgba(0, 29, 50, 0.09);
		content: '';
		height: 4px;
		margin-top: -2px;
		position: absolute;
		top: 50%;
		width: 42%;
	}

	&::before {
		left: 0;
	}

	&::after {
		right: 0;
	}
}

.app-contact-button {
	@include font-open-regular();
	font-weight: bold;
	text-transform: uppercase;

	&[disabled] {
		cursor: not-allowed;
		opacity: 0.5;
	}
}

.form-control {
	min-width: 30%;
}

.app-contact-map {
	margin-top: 60px;
}

.map-contact {
	height: 400px;
	width: 100%;
}

@media screen and (max-width: 600px) {
  .app-contact {
    padding: 30px 0;
  }

  .home-title {
    &::before,
    &::after {
      width: 20%;
    }
  }

  .app-contact-button {
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/commons/app-contact.vue